module.exports = __webpack_public_path__ + "static/media/game(3).d0e4f9f2.PNG";